<div class="breadcrumbs-container">
  <ol class="breadcrumb" #breadcrumb>
    @if (menuData$ | async; as menuData) {
      @if (userIsSystemAdmin) {
        <portal-generic-breadcrumb route="system-admin-system-info" value="System">
          {{ 'portal.system' | portalTranslate }}
        </portal-generic-breadcrumb>
      }
      <!-- Service Provider breadcrumb -->
      @if (activeLevels.isServiceProvider) {
        <portal-generic-breadcrumb
          [value]="menuData.serviceProviderId"
          route="service-provider-enterprises"
        ></portal-generic-breadcrumb>
      }
      <!-- Enterprise breadcrumb -->
      @if (activeLevels.isEnterprise) {
        @if (activeLevels.isServiceProvider) {
          <portal-generic-breadcrumb
            class="d-md-inline d-none"
            *portalHasRole="UserLevel.ServiceProviderAdmin"
            [value]="'breadcrumbs.enterprises' | portalTranslate"
            route="service-provider-enterprises"
          ></portal-generic-breadcrumb>
        }
        <portal-link class="breadcrumb-item" route="end-user-overview">
          <span>{{ menuData.enterpriseId }}</span>
        </portal-link>
      }
      <!-- End User breadcrumb -->
      @if (activeLevels.isEndUser) {
        @if (activeLevels.isEnterprise) {
          <portal-generic-breadcrumb
            class="d-md-inline d-none"
            *portalHasRole="UserLevel.EnterpriseAdmin"
            [value]="'breadcrumbs.users' | portalTranslate"
            route="end-user-overview"
          ></portal-generic-breadcrumb>
        }
        <portal-link class="breadcrumb-item" route="end-user-personalization">
          <span>{{ menuData.userId }}</span>
        </portal-link>
      }
      <!-- Current route -->
      @if (currentRoute?.genericBreadcrumb; as genericBreadcrumb) {
        <ng-container
          *ngTemplateOutlet="genericBreadcrumb.template; context: genericBreadcrumb.context"
        ></ng-container>
      } @else {
        @if (currentRoute) {
          <portal-generic-breadcrumb
            [value]="currentRoute.name | portalTranslate: currentRoute.params"
          ></portal-generic-breadcrumb>
        }
      }
    }
  </ol>
</div>
